import { render, staticRenderFns } from "./team-strategy.vue?vue&type=template&id=fffcc794&scoped=true&"
import script from "./team-strategy.vue?vue&type=script&lang=ts&"
export * from "./team-strategy.vue?vue&type=script&lang=ts&"
import style0 from "./team-strategy.vue?vue&type=style&index=0&id=fffcc794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffcc794",
  null
  
)

export default component.exports